import { UserAreaItem } from 'api/tillit.api-client'
import { Area } from '../user-dialog-context'

export const convertUserAreasToListedAreas = (
  availableAreas: Area[],
  userAreas: UserAreaItem[]
) => availableAreas.filter(area => userAreas.some(ua => ua.areaId === area.id))
